import { render, staticRenderFns } from "./PostsalePromotionsSlider.vue?vue&type=template&id=37f2c437"
import script from "./PostsalePromotionsSlider.vue?vue&type=script&lang=js"
export * from "./PostsalePromotionsSlider.vue?vue&type=script&lang=js"
import style0 from "./PostsalePromotionsSlider.vue?vue&type=style&index=0&id=37f2c437&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports